// RouteLink.js
import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import PrivateRoute from "./Utilities/PrivateRoute";

// Lazy load components for code splitting
const LoginPage = React.lazy(() => import("./Pages/Login/LoginPage"));
const DashboardLayout = React.lazy(() => import("./Layout/DashboardLayout"));
const DashboardHome = React.lazy(
  () => import("./Pages/Dashboard/DashboardHome"),
);

const Category = React.lazy(() => import("./Pages/Category/Category"));
const AddCategory = React.lazy(() => import("./Pages/Category/AddCategory"));

const Brand = React.lazy(() => import("./Pages/Brand/Brand"));
const AddBrand = React.lazy(() => import("./Pages/Brand/AddBrand"));

const SubCategory = React.lazy(() => import("./Pages/SubCategory/SubCategory"));
const AddSubCategory = React.lazy(() => import("./Pages/SubCategory/AddSubCategory"));

const Attribute = React.lazy(() => import("./Pages/Attribute/Attribute"));
const AddAttribute = React.lazy(() => import("./Pages/Attribute/AddAttribute"));

const Product = React.lazy(() => import("./Pages/Product/Product"));
const AddProduct = React.lazy(() => import("./Pages/Product/AddProduct"));

const TaxRate = React.lazy(() => import("./Pages/TaxRate/TaxRate"));
const AddTaxRate = React.lazy(() => import("./Pages/TaxRate/AddTaxRate"));

const Discount = React.lazy(() => import("./Pages/Discount/Discount"));
const AddDiscount = React.lazy(() => import("./Pages/Discount/AddDiscount"));

const Coupon = React.lazy(() => import("./Pages/Coupon/Coupon"));
const AddCoupon = React.lazy(() => import("./Pages/Coupon/AddCoupon"));

const ProductCombo = React.lazy(() =>
  import("./Pages/ProductCombo/ProductCombo")
);
const AddProductCombo = React.lazy(() =>
  import("./Pages/ProductCombo/AddProductCombo")
);

const StockIn = React.lazy(() => import("./Pages/StockIn/StockIn"));

const Order = React.lazy(() => import("./Pages/Order/Order"));


const routes = [
  {
    path: "/login",
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <LoginPage />
      </Suspense>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    element: (
      <Suspense fallback={<div>Loading...</div>}>
        <PrivateRoute />
      </Suspense>
    ), // 🛡 Wrap protected routes here
    children: [
      {
        path: "/dashboard",
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <DashboardLayout />
          </Suspense>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <DashboardHome />
              </Suspense>
            ),
          },
         
          {
            path: "category",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Category />
              </Suspense>
            ),
          },
          {
            path: "categoryadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddCategory />
              </Suspense>
            ),
          },
          //
          {
            path: "brand",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Brand />
              </Suspense>
            ),
          },
          {
            path: "brandadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddBrand />
              </Suspense>
            ),
          },
          //
          {
            path: "subcategory",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <SubCategory />
              </Suspense>
            ),
          },
          {
            path: "subcategoryadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddSubCategory />
              </Suspense>
            ),
          },
          //
          {
            path: "attribute",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Attribute />
              </Suspense>
            ),
          },
          {
            path: "attributeadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddAttribute />
              </Suspense>
            ),
          },
          //
          {
            path: "product",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Product />
              </Suspense>
            ),
          },
          {
            path: "productadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddProduct />
              </Suspense>
            ),
          },
          //
          {
            path: "taxrate",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <TaxRate />
              </Suspense>
            ),
          },
          {
            path: "taxrateadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddTaxRate />
              </Suspense>
            ),
          },
          //
          {
            path: "discount",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Discount />
              </Suspense>
            ),
          },
          {
            path: "discountadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddDiscount />
              </Suspense>
            ),
          },
          //
          {
            path: "coupon",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Coupon />
              </Suspense>
            ),
          },
          {
            path: "couponadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddCoupon />
              </Suspense>
            ),
          },
          //
          {
            path: "productcombo",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <ProductCombo />
              </Suspense>
            ),
          },
          {
            path: "productcomboadd",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <AddProductCombo />
              </Suspense>
            ),
          },
          //
          {
            path: "stockin",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <StockIn />
              </Suspense>
            ),
          },
          //
          {
            path: "order",
            element: (
              <Suspense fallback={<div>Loading...</div>}>
                <Order />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
];

export default routes;

